import { render, staticRenderFns } from "./vue-calculate-myseed.vue?vue&type=template&id=264465e6&scoped=true&"
import script from "./vue-calculate-myseed.vue?vue&type=script&lang=js&"
export * from "./vue-calculate-myseed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "264465e6",
  null
  
)

export default component.exports